import {useSidebar} from "@/src/shared/providers/SidebarProvider";
import {Button} from "@heroui/react";
import {Menu} from "lucide-react";
import {twMerge} from "tailwind-merge";

interface Props {
    text?: string
    children?: React.ReactNode
    className?: string
}

export function Header({text, className, children}: Props) {
    const { toggleSidebar } = useSidebar();

    return (
        <header className={twMerge("flex items-center p-4 m-4 bg-white rounded-xl gap-2", className)}>
            <Button
                isIconOnly
                size="sm"
                variant="light"
                className="md:hidden"
                onPress={toggleSidebar}
            >
                <Menu className="w-5 h-5" />
            </Button>
            {text && (!children) && (<h1 className="text-lg font-semibold">{text}</h1>)}
            {children && children}
        </header>
    );
}